import React from "react";
import { Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { MdAudiotrack } from "react-icons/md";
import Card from "horizon/components/card/Card";

/**
 * Builds the dynamic subtitle text for the services header card.
 * @param {number} count - Items on the current view
 * @param {boolean} searchActive - Whether the user is currently searching
 * @returns {string}
 */
function buildSubtitle(count, searchActive) {
  if (searchActive) {
    if (count === 0) return "Aucun résultat de recherche";
    return `${count} résultat${count > 1 ? "s" : ""} de recherche`;
  }
  if (count === 0) return "Aucun service à afficher";
  return `${count} dernier${count > 1 ? "s" : ""} service${count > 1 ? "s" : ""} créé${count > 1 ? "s" : ""}`;
}

/**
 * Renders the services page header with music icon, title and dynamic subtitle.
 * @param {Object} props - count (number), searchActive (boolean)
 * @returns {React.ReactElement}
 */
function ServicesHeader({ count, searchActive }) {
  const titleColor = useColorModeValue("secondaryGray.900", "white");
  const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
  const badgeBg = useColorModeValue("secondaryGray.300", "navy.700");
  return (
    <Card>
      <Flex align="center" gap="14px">
        <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg}>
          <Icon as={MdAudiotrack} w="22px" h="22px" color="brand.500" />
        </Flex>
        <Flex direction="column" minW="0">
          <Text fontSize="lg" fontWeight="700" color={titleColor}>Services</Text>
          <Text fontSize="sm" color={subColor} noOfLines={1}>{buildSubtitle(count, searchActive)}</Text>
        </Flex>
      </Flex>
    </Card>
  );
}

export default ServicesHeader;
